export const BANNER = 'BANNER'